module.exports = __webpack_public_path__ + "static/media/rw.d896f457.svg";